import React, { useState, useEffect } from "react";

import ReportChart from "./chart/ReportChart";
import './chart/ReportChart.scss';
export default function DashboardReport(props) {
  const [isGraphOpen, setGraphOpen] = useState(false);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [weekData, setWeekData] = useState(false);
  const [monthData, setMonthData] = useState(false);
  const [yearData, setYearData] = useState(false);
  const parseGraphData = (data) => {
    const chartData = {
      xaxis: [],
      data: {
        totalOrder: [],
        successOrder: [],
        failedOrder: [],
      }
    };
    Object.keys(data).map(dt => {
      chartData.xaxis.push(dt) // pushing xaxis data
      return Object.keys(data[dt]).map(orData => {
        chartData.data[orData].push(data[dt][orData])
        return null;
      })
    })
    return chartData
  }
  useEffect(() => {
    const { monthData } = props.report;
    const data = parseGraphData(monthData);
    setData(data)
    setMonthData(true)
    setLoading(false)
  }, [props.report])
  const handleChange = (setweek) => {
    const { monthData, weekData, yearData } = props.report;
    setWeekData(false)
    setMonthData(false)
    setYearData(false)
    if (setweek === 'week') {
      const data = parseGraphData(weekData);
      setData(data)
      setWeekData(true)
    }
    if (setweek === 'month') {
      const data = parseGraphData(monthData);
      setData(data)
      setMonthData(true)
    }
    if (setweek === 'year') {
      const data = parseGraphData(yearData);
      setData(data)
      setYearData(true)
    }
  }
  if (loading)
    return (<div>loading...</div>)

  return (
    // <section className="mt-4 container-fluid">
    // <div className="row">
    <div className="accordion md-accordion" id="accordionEx1" role="tablist" aria-multiselectable="true">

      {/* <!-- Accordion card --> */}
      <div className="card">

        {/* <!-- Card header --> */}
        <div className="card-header" role="tab" id="headingTwo1">
          <a className="collapsed" data-toggle="collapse" data-parent="#accordionEx1" href="#collapseTwo1"
            aria-expanded="false" aria-controls="collapseTwo1">
            <h5 onClick={() => { setGraphOpen(!isGraphOpen) }} className="mb-0">
              {isGraphOpen ? "Hide report graph" : "Show report graph"} <i className="fa fa-angle-down rotate-icon"></i>
            </h5>
          </a>
        </div>

        {/* <!-- Card body --> */}
        <div id="collapseTwo1" className="collapse" role="tabpanel" aria-labelledby="headingTwo1"
          data-parent="#accordionEx1">
          {/* <div className="col-sm-12"> */}
          <div className="card">
            <div className="card-body">
              <h1 className="sec-header float-left">REPORT</h1>
              <div className="float-right report-btn">
                <ul className="chart-data">
                  <li className={weekData ? 'btn-active' : undefined} onClick={() => handleChange('week')}>Week</li>
                  <li className={monthData ? 'btn-active' : undefined} onClick={() => handleChange('month')}>Month</li>
                  <li className={yearData ? 'btn-active' : undefined} onClick={() => handleChange('year')}>Year</li>
                </ul>
              </div>
              <div id="chart">
                <ReportChart chData={data} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </div>
    // </div>
    // </section>


  );
}
